<template>
  <v-container fluid class="org-select">
    <div class="org-select__bg"></div>
    <div class="org-select__glow"></div>
    <v-row align="center" justify="center" class="org-select__content">
      <v-col cols="12" sm="10" md="7" lg="5">
        <div class="org-select__card">
          <div class="org-select__badge">
            {{ $t('orgSelect.badge') }}
          </div>
          <h1 class="org-select__title">{{ $t('orgSelect.title') }}</h1>
          <p class="org-select__subtitle">{{ $t('orgSelect.subtitle') }}</p>
          <v-form @submit.prevent="submit">
            <v-text-field
              v-model="orgSlug"
              :label="$t('orgSelect.label')"
              :placeholder="$t('orgSelect.placeholder')"
              :error-messages="error"
              outlined
              dense
              class="org-select__input"
            />
            <div class="org-select__actions">
              <v-btn class="org-select__primary" type="submit" large>
                {{ $t('orgSelect.continue') }}
              </v-btn>
              <v-btn text class="org-select__demo" @click="useDemoOrg">
                {{ $t('orgSelect.useDemo') }}
              </v-btn>
            </div>
          </v-form>
          <p class="org-select__hint">{{ $t('orgSelect.hint') }}</p>
        </div>
      </v-col>
      <v-col cols="12" lg="5" class="org-select__aside">
        <div class="org-select__aside-card">
          <h2>{{ $t('orgSelect.asideTitle') }}</h2>
          <ul>
            <li>{{ $t('orgSelect.asidePoint1') }}</li>
            <li>{{ $t('orgSelect.asidePoint2') }}</li>
            <li>{{ $t('orgSelect.asidePoint3') }}</li>
          </ul>
          <div class="org-select__aside-footer">
            <span>{{ $t('orgSelect.remember') }}</span>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getOrgSlug, setOrgSlug } from '@/utils/org'

export default {
  name: 'OrgSelect',
  data () {
    return {
      orgSlug: getOrgSlug() || '',
      error: ''
    }
  },
  computed: {
    ...mapGetters(['locale'])
  },
  methods: {
    submit () {
      const cleaned = (this.orgSlug || '').trim().toLowerCase()
      if (!cleaned) {
        this.error = this.$t('orgSelect.errorRequired')
        return
      }
      if (!/^[a-z0-9-]+$/.test(cleaned)) {
        this.error = this.$t('orgSelect.errorInvalid')
        return
      }
      this.error = ''
      setOrgSlug(cleaned)
      this.$store.dispatch('GET_ORG_THEME', { orgSlug: cleaned, locale: this.locale })
      this.$router.push({ name: 'login' })
    },
    useDemoOrg () {
      this.orgSlug = 'demo-org'
      this.submit()
    }
  }
}
</script>

<style lang="scss" scoped>
.org-select {
  min-height: 100vh;
  padding: 48px 20px;
  position: relative;
  overflow: hidden;
  background: radial-gradient(1200px 600px at 10% 10%, #e6f0ff 0%, #f5f7fb 55%, #fbf4e8 100%);
  font-family: var(--enfont, "Source Sans Pro");
}

.org-select__bg {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(120deg, rgba(15, 35, 75, 0.05), rgba(255, 165, 72, 0.08));
  mix-blend-mode: multiply;
  pointer-events: none;
}

.org-select__glow {
  position: absolute;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  background: rgba(31, 75, 153, 0.15);
  filter: blur(80px);
  top: -120px;
  right: -120px;
  pointer-events: none;
}

.org-select__content {
  position: relative;
  z-index: 1;
}

.org-select__card {
  background: #ffffff;
  border-radius: 24px;
  padding: 36px 32px;
  box-shadow: 0 24px 60px rgba(15, 35, 75, 0.12);
}

.org-select__badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(31, 75, 153, 0.08);
  color: #1f4b99;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-size: 12px;
}

.org-select__title {
  font-size: 32px;
  margin: 18px 0 10px;
  color: #0f234b;
  font-weight: 700;
}

.org-select__subtitle {
  margin: 0 0 24px;
  color: #4a5a74;
  font-size: 16px;
}

.org-select__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.org-select__primary {
  background: #1f4b99;
  color: #ffffff;
  text-transform: none;
  letter-spacing: 0.02em;
  box-shadow: 0 10px 20px rgba(31, 75, 153, 0.25);
}

.org-select__demo {
  text-transform: none;
  color: #1f4b99;
}

.org-select__hint {
  margin-top: 18px;
  font-size: 13px;
  color: #7a8599;
}

.org-select__aside {
  display: none;
}

.org-select__aside-card {
  background: rgba(255, 255, 255, 0.8);
  padding: 28px;
  border-radius: 20px;
  border: 1px solid rgba(31, 75, 153, 0.1);
  backdrop-filter: blur(8px);
}

.org-select__aside-card h2 {
  font-size: 22px;
  margin-bottom: 14px;
  color: #1f2e4a;
}

.org-select__aside-card ul {
  padding-left: 18px;
  margin: 0;
  color: #4a5a74;
}

.org-select__aside-card li {
  margin-bottom: 10px;
}

.org-select__aside-footer {
  margin-top: 18px;
  font-size: 13px;
  color: #7a8599;
}

@media (min-width: 960px) {
  .org-select__aside {
    display: block;
  }
}
</style>
